module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<div id="netsim-panel-<%= instanceID %>"\n     class="netsim-panel <%= className %>">\n  <h1>\n    <div class="panel-controls"></div>\n    <div class="single-line-with-ellipsis pad-left<% if (userToggleable) { %> minimizer<% } %>">\n      <% if (userToggleable) { %>\n        <i class="fa fa-minus-square"></i>\n      <% } %>\n      <span class="title-text"><%= panelTitle %></span>\n    </div>\n  </h1>\n  <div class="panel-body">\n  </div>\n</div>\n', __filename = "src/netsim/NetSimPanel.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            __append('<div id="netsim-panel-');
            __append(escapeFn(instanceID));
            __append('"\n     class="netsim-panel ');
            __line = 2;
            __append(escapeFn(className));
            __append('">\n  <h1>\n    <div class="panel-controls"></div>\n    <div class="single-line-with-ellipsis pad-left');
            __line = 5;
            if (userToggleable) {
                __append(" minimizer");
            }
            __append('">\n      ');
            __line = 6;
            if (userToggleable) {
                __append('\n        <i class="fa fa-minus-square"></i>\n      ');
                __line = 8;
            }
            __append('\n      <span class="title-text">');
            __line = 9;
            __append(escapeFn(panelTitle));
            __append('</span>\n    </div>\n  </h1>\n  <div class="panel-body">\n  </div>\n</div>\n');
            __line = 15;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}